module.exports = __webpack_public_path__ + "static/media/IMG_1474.ac71651e.JPG";